import React, { useEffect, useRef, useState } from "react";
import AboutUs from "./AboutUs";
import CounterSection from "./CounterSection";
import Logo from "./Logo";
import "../BoxGrid.css";
import VisitorTracker from "./VisitorTracker";
import { Link } from "react-router-dom";
import "../Footer.css";
import "../Logo.css";
import "../Cards.css";

const Home = () => {
  const servicesRef = useRef(null);
  const industriesRef = useRef(null);
  const [visitorLocation, setVisitorLocation] = useState({
    city: "",
    country: "",
    ip: "",
    region: "",
  });

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch("https://ipinfo.io/json");
        const data = await response.json();

        console.log(data);

        setVisitorLocation({
          city: data.city || "",
          country: data.country || "",
          ip: data.ip || "",
          region: data.region || "",
        });
      } catch (error) {
        console.error(error);
      }
    };

    fetchLocation();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" },
    );

    const serviceBoxes = document.querySelectorAll(".service-box");
    serviceBoxes.forEach((box) => observer.observe(box));

    if (industriesRef.current) {
      observer.observe(industriesRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <VisitorTracker />
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(40px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInLeft {
            from {
              opacity: 0;
              transform: translateX(-50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes fadeInRight {
            from {
              opacity: 0;
              transform: translateX(50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes scaleIn {
            from {
              opacity: 0;
              transform: scale(0.9);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes float {
            0% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-20px);
            }
            100% {
              transform: translateY(0px);
            }
          }

          @keyframes glow {
            0% {
              box-shadow: 0 0 5px rgba(32, 117, 207, 0.5);
            }
            50% {
              box-shadow: 0 0 25px rgba(32, 117, 207, 0.8);
            }
            100% {
              box-shadow: 0 0 5px rgba(32, 117, 207, 0.5);
            }
          }

          @keyframes slideInStagger {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .hero-section {
            background: linear-gradient(135deg, #2075cf 0%, #1a5fa8 50%, #0d4a8a 100%);
            position: relative;
            overflow: hidden;
          }

          .hero-section::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000"><circle cx="500" cy="500" r="300" fill="rgba(255,255,255,0.03)"/><circle cx="1500" cy="1000" r="400" fill="rgba(255,255,255,0.02)"/><circle cx="1000" cy="1600" r="350" fill="rgba(255,255,255,0.03)"/></svg>');
            background-size: cover;
            pointer-events: none;
          }

          .hero-section .carousel-item {
            min-height: 550px;
          }

          .hero-section .row.align-items-center {
            min-height: 550px;
          }

          .hero-content {
            padding-left: 40px;
            position: relative;
            z-index: 2;
          }

          .hero-title {
            font-size: 56px;
            font-weight: 800;
            line-height: 1.2;
            margin-bottom: 20px;
            background: linear-gradient(135deg, #fff 0%, #e8f0fe 100%);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            text-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }

          .animated-text-wrapper {
            min-height: 120px;
            margin-bottom: 15px;
          }

          .animated-word {
            display: inline-block;
            opacity: 0;
            transform: translateY(40px);
            animation: slideInStagger 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1) forwards;
            color:#fff;
          }

          .hero-text {
            font-size: 18px;
            line-height: 1.6;
            color: rgba(255, 255, 255, 0.9);
            max-width: 550px;
            opacity: 0;
            animation: fadeInUp 0.8s ease-out 0.8s forwards;
          }

          .hero-buttons {
            opacity: 0;
            animation: fadeInUp 0.8s ease-out 1.1s forwards;
          }

          .hero-btn {
            padding: 12px 32px;
            font-size: 16px;
            border-radius: 50px;
            font-weight: 600;
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .hero-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(255,255,255,0.3);
            transform: translate(-50%, -50%);
            transition: width 0.6s, height 0.6s;
          }

          .hero-btn:hover::before {
            width: 300px;
            height: 300px;
          }

          .hero-btn-light {
            background: white;
            color: #2075cf;
            border: none;
          }

          .hero-btn-light:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 30px rgba(0,0,0,0.2);
            background: white;
            color: #2075cf;
          }

          .hero-btn-outline {
            background: transparent;
            border: 2px solid white;
            color: white;
          }

          .hero-btn-outline:hover {
            background: white;
            color: #2075cf;
            transform: translateY(-3px);
          }

          .hero-image {
            max-height: 400px;
            animation: float 5s ease-in-out infinite;
            filter: drop-shadow(0 20px 30px rgba(0,0,0,0.15));
          }

          .carousel-indicators [data-bs-target] {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            transition: all 0.3s ease;
            margin: 0 6px;
          }

          .carousel-indicators .active {
            transform: scale(1.3);
            background-color: #ffd700;
            width: 12px;
            height: 12px;
          }

          .carousel-control-prev,
          .carousel-control-next {
            width: 40px;
            height: 40px;
            background: rgba(255,255,255,0.2);
            border-radius: 50%;
            top: 50%;
            transform: translateY(-50%);
            opacity: 0.6;
            transition: all 0.3s ease;
          }

          .hero-section:hover .carousel-control-prev,
          .hero-section:hover .carousel-control-next {
            opacity: 1;
          }

          .carousel-control-prev {
            left: 20px;
          }

          .carousel-control-next {
            right: 20px;
          }

          .services-section {
            background: linear-gradient(to bottom, #ffffff, #f0f7ff);
          }

          .section-badge {
            display: inline-block;
            background: linear-gradient(135deg, #2075cf 0%, #1a5fa8 100%);
            color: white;
            padding: 6px 18px;
            border-radius: 50px;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 1px;
            margin-bottom: 20px;
          }

          .service-box {
            background: white;
            border-radius: 20px;
            padding: 40px 25px;
            text-align: center;
            transition: all 0.4s ease;
            box-shadow: 0 10px 30px rgba(0,0,0,0.05);
            border: 1px solid rgba(32, 117, 207, 0.1);
            opacity: 0;
            transform: translateY(30px);
            transition: all 0.6s ease;
            display: flex;
            flex-direction: column;
            height: 100%;
          }

          .service-box p {
            flex-grow: 1;
            margin-bottom: 20px;
          }

          .service-box a {
            align-self: center;
            margin-top: auto;
          }

          .service-box.animate-in {
            opacity: 1;
            transform: translateY(0);
          }

          .service-box:hover {
            transform: translateY(-10px);
            box-shadow: 0 25px 50px rgba(32, 117, 207, 0.15);
            border-color: rgba(32, 117, 207, 0.2);
          }

          .service-box i {
            font-size: 48px;
            background: linear-gradient(135deg, #2075cf 0%, #1a5fa8 100%);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            margin-bottom: 20px;
            display: block;
            text-align: center;
            margin-left: auto;
            margin-right: auto;
          }

          .service-box h3 {
            font-size: 22px;
            font-weight: 700;
            margin-bottom: 15px;
            color: #1a1a2e;
          }

          .service-box p {
            color: #666;
            line-height: 1.6;
          }

          .service-box a {
            color: #2075cf;
            text-decoration: none;
            font-weight: 600;
            transition: all 0.3s ease;
            display: inline-flex;
            align-items: center;
            gap: 5px;
          }

          .service-box a::after {
            content: '→';
            transition: transform 0.3s ease;
          }

          .service-box a:hover::after {
            transform: translateX(5px);
          }

          .service-box-gradient {
            background: linear-gradient(135deg, #2075cf 0%, #1a5fa8 100%);
            color: white;
          }

          .service-box-gradient i,
          .service-box-gradient h3,
          .service-box-gradient p {
            color: white !important;
            background: none !important;
            -webkit-background-clip: unset !important;
          }

          .service-box-gradient a {
            color: #ffd700;
          }

          .industries-section {
            background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
            border-radius: 40px;
            margin: 60px 0;
            padding: 60px 40px;
            opacity: 0;
            transform: translateY(30px);
            transition: all 0.8s ease;
          }

          .industries-section.animate-in {
            opacity: 1;
            transform: translateY(0);
          }

          @media (min-width: 1200px) {
            .hero-section .carousel-item,
            .hero-section .row.align-items-center {
              min-height: 600px;
            }
            .hero-title {
              font-size: 60px;
            }
            .hero-image {
              max-height: 500px;
            }
          }

          @media (max-width: 1199px) and (min-width: 992px) {
            .hero-section .carousel-item,
            .hero-section .row.align-items-center {
              min-height: 550px;
            }
            .hero-title {
              font-size: 50px;
            }
            .hero-text {
              font-size: 17px;
            }
            .hero-image {
              max-height: 410px;
            }
            .animated-text-wrapper {
              min-height: 110px;
            }
          }

          @media (max-width: 991px) {
            .hero-section .carousel-item,
            .hero-section .row.align-items-center {
              min-height: 450px;
              margin-top: 43px;
            }
            .hero-title {
              font-size: 42px;
            }
            .hero-text {
              font-size: 16px;
            }
            .hero-content {
              padding-left: 20px;
            }
            .hero-image {
              max-height: 400px;
            }
            .animated-text-wrapper {
              min-height: 100px;
            }
            .hero-btn {
              padding: 10px 28px;
              font-size: 15px;
            }
          }

          @media (max-width: 767px) {
            .hero-section .carousel-item,
            .hero-section .row.align-items-center {
              min-height: auto;
              padding: 50px 0;
            }
            .hero-title {
              font-size: 36px;
              text-align: center;
            }
            .animated-text-wrapper {
              min-height: auto;
              text-align: center;
            }
            .hero-text {
              font-size: 15px;
              text-align: center;
              margin-left: auto;
              margin-right: auto;
            }
            .hero-content {
              text-align: center;
              padding-left: 0;
              margin-bottom: 30px;
            }
            .hero-image {
              max-height: 290px;
              margin-top: 20px;
            }
            .hero-buttons {
              display: flex;
              flex-direction: row;
              gap: 15px;
              justify-content: center;
            }
            .hero-btn {
              padding: 10px 24px;
              font-size: 14px;
            }
            .hero-btn.me-3 {
              margin-right: 0 !important;
            }
            .carousel-control-prev,
            .carousel-control-next {
              opacity: 0.5;
              width: 32px;
              height: 32px;
            }
            .service-box {
              padding: 30px 20px;
              margin-bottom: 20px;
            }
          }

          @media (max-width: 575px) {
            .hero-section .carousel-item,
            .hero-section .row.align-items-center {
              padding: 40px 0;
            }
            .hero-title {
              font-size: 28px;
            }
            .hero-text {
              font-size: 14px;
            }
            .hero-image {
              max-height: 200px;
            }
            .hero-buttons {
              flex-direction: column;
              align-items: center;
              gap: 12px;
            }
            .hero-btn {
              width: 180px;
              padding: 8px 20px;
              font-size: 13px;
            }
            .section-badge {
              font-size: 12px;
            }
            .services-section h1.display-5 {
              font-size: 28px;
            }
            .services-section .fs-5 {
              font-size: 14px !important;
            }
            .industries-section {
              padding: 40px 20px;
              margin: 40px 20px;
            }
          }

          @media (max-width: 380px) {
            .hero-title {
              font-size: 24px;
            }
            .hero-text {
              font-size: 13px;
            }
            .hero-image {
              max-height: 170px;
            }
            .hero-btn {
              width: 160px;
              padding: 7px 16px;
              font-size: 12px;
            }
            .carousel-control-prev,
            .carousel-control-next {
              width: 28px;
              height: 28px;
            }
          }

          .why-section {
            position: relative;
            overflow: hidden;
            background: linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%);
            z-index: 1;
            padding: 10px 0;
          }

          .why-section::before,
          .why-section::after {
            content: "";
            position: absolute;
            border-radius: 50%;
            filter: blur(80px);
            opacity: 0.4;
            z-index: -1;
            animation: moveBlob 10s infinite alternate ease-in-out;
            pointer-events: none;
          }

          .why-section::before {
            width: 350px;
            height: 350px;
            background: #7b4dff;
            top: -100px;
            left: -100px;
          }

          .why-section::after {
            width: 300px;
            height: 300px;
            background: #00c8d7;
            bottom: -100px;
            right: -100px;
            animation-delay: 3s;
          }

          @keyframes moveBlob {
            0% {
              transform: translate(0, 0) scale(1);
            }
            50% {
              transform: translate(40px, 30px) scale(1.1);
            }
            100% {
              transform: translate(-20px, -30px) scale(0.95);
            }
          }

          .why-section .particle {
            position: absolute;
            width: 12px;
            height: 12px;
            background: rgba(123, 77, 255, 0.2);
            border-radius: 50%;
            animation: floatParticle 12s linear infinite;
            pointer-events: none;
            z-index: 0;
          }

          .why-section .particle:nth-child(even) {
            background: rgba(0, 200, 215, 0.25);
            width: 10px;
            height: 10px;
            animation-duration: 14s;
          }

          .why-section .particle:nth-child(3n) {
            width: 15px;
            height: 15px;
            background: rgba(123, 77, 255, 0.15);
            animation-duration: 10s;
          }

          @keyframes floatParticle {
            0% {
              transform: translateY(0px) translateX(0px);
              opacity: 0;
            }
            20% {
              opacity: 1;
            }
            100% {
              transform: translateY(-800px) translateX(100px);
              opacity: 0;
            }
          }

          .big-circle {
            width: 450px;
            height: 450px;
            background: rgba(255, 255, 255, 0.75);
            backdrop-filter: blur(3px);
            border-radius: 50%;
            position: relative;
            margin: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 20px 35px rgba(0, 0, 0, 0.05);
            transition: all 0.3s ease;
          }

          .main-circle {
            width: 180px;
            height: 180px;
            background: linear-gradient(135deg, #7b4dff, #4d2dff);
            border-radius: 50%;
            color: white;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
            text-align: center;
            transition: transform 0.3s ease;
          }

          .main-circle:hover {
            transform: scale(1.02);
          }

          .main-circle h1,
          .main-circle h2 {
            margin: 0;
            font-weight: 700;
            line-height: 1.2;
          }

          .main-circle h1 {
            font-size: 38px;
          }

          .main-circle h2 {
            font-size: 28px;
          }

          .floating-icon {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            font-size: 28px;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
            animation: float 4s ease-in-out infinite;
            transition: transform 0.3s ease, box-shadow 0.2s;
            cursor: pointer;
          }

          .floating-icon:hover {
            transform: scale(1.15);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);
          }

          .icon-1 {
            background: #7b4dff;
            top: 20px;
            right: 80px;
          }

          .icon-2 {
            background: #5d8bff;
            top: 140px;
            right: -20px;
          }

          .icon-3 {
            background: #00c8d7;
            bottom: 120px;
            right: 10px;
          }

          .icon-4 {
            background: #888;
            bottom: 20px;
            left: 120px;
          }

          .why-card {
            display: flex;
            align-items: flex-start;
            gap: 20px;
            margin-bottom: 5px;
            transition: all 0.4s ease;
            background: transparent;
            padding: 8px 12px;
            border-radius: 24px;
          }

          .why-card:hover {
            transform: translateX(10px);
            background: rgba(255, 255, 255, 0.65);
            box-shadow: 0 8px 18px rgba(0, 0, 0, 0.05);
          }

          .why-icon {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            flex-shrink: 0;
            transition: transform 0.2s;
          }

          .why-card:hover .why-icon {
            transform: scale(1.05);
          }

          .purple {
            background: #7b4dff;
          }

          .blue {
            background: #5d8bff;
          }

          .cyan {
            background: #00c8d7;
          }

          .gray {
            background: #888;
          }

          .why-card h4 {
            font-weight: 700;
            margin-bottom: 8px;
            font-size: 1.45rem;
          }

          .why-card p {
            color: #4b5563;
            line-height: 1.7;
          }

          @media (max-width: 768px) {
            .why-section {
              padding: 60px 0;
            }

            .big-circle {
              width: 320px;
              height: 320px;
            }

            .main-circle {
              width: 140px;
              height: 140px;
            }

            .main-circle h1 {
              font-size: 28px;
            }

            .main-circle h2 {
              font-size: 20px;
            }

            .floating-icon {
              width: 55px;
              height: 55px;
              font-size: 22px;
            }

            .icon-1 {
              right: 30px;
              top: 10px;
            }

            .icon-2 {
              right: -10px;
              top: 110px;
            }

            .icon-3 {
              bottom: 100px;
              right: 0px;
            }

            .icon-4 {
              bottom: 20px;
              left: 80px;
            }

            .why-card {
              margin-bottom: 28px;
            }

            .display-5 {
              font-size: 2rem;
            }
          }

          @media (max-width: 550px) {
            .why-section .particle {
              display: none;
            }
          }
        `}
      </style>

      <div className="hero-section container-fluid" style={{ paddingTop: "70px" }}>
        <div
          id="heroCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="4500"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            />
            <button
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            />
            <button
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            />
          </div>

          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-6 text-white hero-content">
                    <div className="animated-text-wrapper">
                      <h1 className="hero-title">
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.05s" }}
                        >
                          Perfect
                        </span>{" "}
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.1s" }}
                        >
                          Design.
                        </span>
                        <br />
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.2s" }}
                        >
                          Incredible
                        </span>{" "}
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.25s" }}
                        >
                          Experience.
                        </span>
                      </h1>
                    </div>
                    <p className="hero-text">
                      DigiOpen Services Helps Transform Your Ideas Into World-Class Digital Products With Modern Technology Solutions That Drive Real Business Growth.
                    </p>
                    <div className="hero-buttons mt-4">
                      <Link
                        to="/contact"
                        className="btn hero-btn hero-btn-light me-3"
                      >
                        Contact
                      </Link>
                      <Link
                        to="/about"
                        className="btn hero-btn hero-btn-outline"
                      >
                        About Us
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-6 text-center">
                    <img
                      src="img/hero-mock.png"
                      alt="hero"
                      className="img-fluid hero-image"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-6 text-white hero-content">
                    <div className="animated-text-wrapper">
                      <h1 className="hero-title">
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.05s" }}
                        >
                          Smart
                        </span>{" "}
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.1s" }}
                        >
                          Business
                        </span>
                        <br />
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.2s" }}
                        >
                          Automation
                        </span>{" "}
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.25s" }}
                        >
                          Solutions.
                        </span>
                      </h1>
                    </div>
                    <p className="hero-text">
                      Automate Your Workflow With Cutting-Edge ERP Solutions And Modern Business Tools Designed For Faster, Smarter Company Growth.
                    </p>
                    <div className="hero-buttons mt-4">
                      <Link
                        to="/contact"
                        className="btn hero-btn hero-btn-light me-3"
                      >
                        Contact
                      </Link>
                      <Link
                        to="/about"
                        className="btn hero-btn hero-btn-outline"
                      >
                        About Us
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-6 text-center">
                    <img
                      src="img/4.png"
                      width={450}
                      height={450}
                      alt="hero"
                      className="img-fluid hero-image"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-6 text-white hero-content">
                    <div className="animated-text-wrapper">
                      <h1 className="hero-title">
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.05s" }}
                        >
                          Build
                        </span>{" "}
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.1s" }}
                        >
                          Powerful
                        </span>
                        <br />
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.2s" }}
                        >
                          Digital
                        </span>{" "}
                        <span
                          className="animated-word"
                          style={{ animationDelay: "0.25s" }}
                        >
                          Products.
                        </span>
                      </h1>
                    </div>
                    <p className="hero-text">
                      From Web Development To Mobile Apps And Scalable Software Solutions, We Help You Build Powerful Digital Products That Stand Out.
                    </p>
                    <div className="hero-buttons mt-4">
                      <Link
                        to="/contact"
                        className="btn hero-btn hero-btn-light me-3"
                      >
                        Contact
                      </Link>
                      <Link
                        to="/about"
                        className="btn hero-btn hero-btn-outline"
                      >
                        About Us
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-6 text-center">
                    <img
                      src="img/2.png"
                      width={450}
                      height={450}
                      alt="hero"
                      className="img-fluid hero-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      <div className="services-section container py-3">
        <div className="container text-center pt-2">
          <span className="section-badge">What We Do</span>
          <h1 className="fw-bold display-5 mb-3">Our Services</h1>
          <p
            className="fs-5 text-secondary px-5 mx-auto"
            style={{ maxWidth: "1000px" }}
          >
            We invite you to be part of a team of thinkers and doers. Work at DigiOpen Services, where top business and technology professionals are always up to something new.
          </p>
        </div>

        <div className="row g-4 mt-3">
          <div className="col-md-6 col-lg-4">
            <div className="service-box" style={{ animationDelay: "0.1s" }}>
              <i className="fa-solid fa-briefcase"></i>
              <h3>Business Consulting</h3>
              <p>
                We At DigiOpen Services Provide Process Assessment Consulting By Evaluating...
              </p>
              <Link to="/businessconsulting">Learn More</Link>
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <div
              className="service-box service-box-gradient"
              style={{ animationDelay: "0.2s" }}
            >
              <i className="fa-solid fa-layer-group"></i>
              <h3>ERP Consulting</h3>
              <p>
                At DigiOpen Services, We Provide ERP Consultation To Customers, Including Professional.
              </p>
              <Link to="/consulting">Learn More</Link>
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <div className="service-box" style={{ animationDelay: "0.3s" }}>
              <i className="fa-solid fa-print"></i>
              <h3>ERP Implementation</h3>
              <p>
                At DigiOpen Services, During ERP Implementation, We Deploy, Configure, And Integrate Software...
              </p>
              <Link to="/ERPimplementation">Learn More</Link>
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <div
              className="service-box service-box-gradient"
              style={{ animationDelay: "0.4s" }}
            >
              <i className="fa-solid fa-mobile"></i>
              <h3>Mobile Development</h3>
              <p>
                We've Been Performing The Role Of The Remote App Development Team For Companies...
              </p>
              <Link to="/appdevelopment">Learn More</Link>
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <div className="service-box" style={{ animationDelay: "0.5s" }}>
              <i className="fa-solid fa-box"></i>
              <h3>Product Development</h3>
              <p>
                This Offering Includes The Complete Range Of Software Engineering Services..
              </p>
              <Link to="/productdevelopment">Learn More</Link>
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <div
              className="service-box service-box-gradient"
              style={{ animationDelay: "0.6s" }}
            >
              <i className="fa-solid fa-computer"></i>
              <h3>Web Development</h3>
              <p>
                At DigiOpen Services, We Create Modern, Scalable, And High-Performing Web Solutions..
              </p>
              <Link to="/WebDevelopment">Learn More</Link>
            </div>
          </div>
        </div>
      </div>

      <AboutUs />
      <CounterSection />

      <div className="why-section">
        <div className="particle" style={{ left: "10%", bottom: "0%" }}></div>
        <div className="particle" style={{ left: "25%", bottom: "-20%" }}></div>
        <div className="particle" style={{ left: "50%", bottom: "-10%" }}></div>
        <div className="particle" style={{ left: "70%", bottom: "-30%" }}></div>
        <div className="particle" style={{ left: "90%", bottom: "-15%" }}></div>

        <div
          className="particle"
          style={{ left: "15%", top: "20%", animationDuration: "14s" }}
        ></div>
        <div
          className="particle"
          style={{ left: "85%", top: "40%", animationDuration: "18s" }}
        ></div>
        <div
          className="particle"
          style={{ left: "40%", top: "70%", animationDuration: "13s" }}
        ></div>
        <div
          className="particle"
          style={{ left: "60%", top: "85%", animationDuration: "16s" }}
        ></div>

        <div className="container py-2">
          <div className="text-center mb-1">
            <span className="section-badge">Why Choose Us</span>
            <h1 className="fw-bold display-5">Why Clients Choose DigiOpen</h1>
            <p className="text-secondary fs-5">
              We deliver modern digital solutions with innovation, speed and quality.
            </p>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-6 position-relative text-center mb-5 mb-lg-0">
              <div className="big-circle">
                <div className="main-circle">
                  <h1>WHY</h1>
                  <h2>CHOOSE</h2>
                  <h2>US</h2>
                </div>
                <div className="floating-icon icon-1">
                  <i className="fa-solid fa-gem"></i>
                </div>
                <div className="floating-icon icon-2">
                  <i className="fa-solid fa-stopwatch"></i>
                </div>
                <div className="floating-icon icon-3">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>
                <div className="floating-icon icon-4">
                  <i className="fa-solid fa-user"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="why-card">
                <div className="why-icon purple">
                  <i className="fa-solid fa-gem"></i>
                </div>
                <div>
                  <h4>Premium Quality</h4>
                  <p>
                    We provide high-quality scalable software solutions with modern technologies.
                  </p>
                </div>
              </div>

              <div className="why-card">
                <div className="why-icon blue">
                  <i className="fa-solid fa-stopwatch"></i>
                </div>
                <div>
                  <h4>Fast Delivery</h4>
                  <p>
                    Our expert team ensures projects are delivered on time with maximum efficiency.
                  </p>
                </div>
              </div>

              <div className="why-card">
                <div className="why-icon cyan">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>
                <div>
                  <h4>User Friendly</h4>
                  <p>
                    We create clean and intuitive user experiences for every platform.
                  </p>
                </div>
              </div>

              <div className="why-card">
                <div className="why-icon gray">
                  <i className="fa-solid fa-user"></i>
                </div>
                <div>
                  <h4>Client Satisfaction</h4>
                  <p>
                    Customer satisfaction and long-term relationships are our top priorities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Logo />
    </>
  );
};

export default Home;